import React, { useState, useEffect } from 'react';
import { SocialLinks } from './PortfolioComponents';
import '../styles/Archive.css';

const Archive = () => {
  const [menuState, setMenuState] = useState(false);

  const toggleMenu = () => {
    setMenuState(prevState => {
      if (!prevState) return 'active';
      return prevState === 'deactive' ? 'active' : 'deactive';
    });
  };

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  // Array of image numbers based on the HTML file
  const images = [4, 2, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 33, 34, 35, 36, 37, 38, 39];
  const videos = [1, 2, 3, 4, 5, 6, 7, 8];

  return (
    <div className="archive-page">
      {/* Menu overlay */}
      <div className={`menu-container ${menuState}`}>
        <div className="overlay" />
        <div className="menu-items">
          <ul>
            <li>
              <a href="/" onClick={toggleMenu}>
                HOME
              </a>
            </li>
            <li>
              <a href="/#about" onClick={toggleMenu}>
                ABOUT
              </a>
            </li>
            <li>
              <a href="/#projects" onClick={toggleMenu}>
                PORTFOLIO
              </a>
            </li>
            <li>
              <a href="/blog" onClick={toggleMenu}>
                BLOG
              </a>
            </li>
            <li>
              <a href="/archive/2024/uoh/soupbg" onClick={toggleMenu}>
                ARCHIVE
              </a>
            </li>
          </ul>
          <SocialLinks />
        </div>
      </div>

      {/* Navigation */}
      <nav id="navbar" className="archive-nav">
        <div className="nav-wrapper">
          <p className="brand">
            <a href="/" style={{ color: '#fefae0', textDecoration: 'none' }}>
              Dhanush <strong>SR Kenkiri</strong>
            </a>
          </p>
          <button
            onClick={toggleMenu}
            className={menuState === 'active' ? 'menu-button active' : 'menu-button'}
            aria-label="Toggle menu"
          >
            <span />
          </button>
        </div>
      </nav>

      <h1>Soup Boys&Girls - 2024</h1>
      <div className="archive-container">
        {images.map((num) => (
          <div className="media-item" key={`img-${num}`}>
            <img 
              src={`/archive/2024/uoh/images/images (${num}).jpg`} 
              alt={`Soup Boys and Girls event ${num}`}
              loading="lazy"
            />
          </div>
        ))}
        
        {videos.map((num) => (
          <div className="media-item" key={`vid-${num}`}>
            <video 
              src={`/archive/2024/uoh/images/images (${num}).mp4`} 
              controls 
              controlsList="nodownload"
              preload="metadata"
            />
          </div>
        ))}
      </div>
      
      <a href="/" className="website-button">
        Visit My Website
      </a>
      
      <footer>
        <div className="wrapper">
          <h3>THANKS FOR VISITING</h3>
          <p>© 2020 - {new Date().getFullYear()} Made with ❤️ - DSRK</p>
          <SocialLinks />
        </div>
      </footer>
    </div>
  );
};

export default Archive;
